import { render, staticRenderFns } from "./Trending.vue?vue&type=template&id=3d75aaee"
import script from "./Trending.vue?vue&type=script&lang=js"
export * from "./Trending.vue?vue&type=script&lang=js"
import style0 from "./Trending.vue?vue&type=style&index=0&id=3d75aaee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports